import { filterTypesEnum, type FilterOption } from "@/types/common/filters";
import { buildHierarchyStatusFilter } from "./serialization";

export const defaultFilters: (val: {
  status?: string;
  created_at?: string;
  suspensionStatus?: string;
}) => FilterOption[] = ({
  status = "",
  created_at = "",
  suspensionStatus = "",
}) => [
  {
    id: 1,
    field: "created_at",
    type: filterTypesEnum.dates,
    label: "Última actualización",
    shouldDisabledFutureDates: true,
    isUpdated: created_at !== "",
    result: created_at,
  },
  buildHierarchyStatusFilter(status) as FilterOption,
  {
    id: 3,
    field: "suspensionStatus",
    type: filterTypesEnum.status,
    label: "Estado de suspención",
    isUpdated: suspensionStatus !== "",
    result: suspensionStatus,
    status: [
      {
        field: "PENDING",
        label: "Pendiente",
        value: suspensionStatus.includes("PENDING"),
      },
      {
        field: "APPROVED",
        label: "Aprobado",
        value: suspensionStatus.includes("APPROVED"),
      },
      {
        field: "DENIED",
        label: "Denegado",
        value: suspensionStatus.includes("DENIED"),
      },
      {
        field: "SCALED",
        label: "Escalado",
        value: suspensionStatus.includes("SCALED"),
      },
    ],
  },
];
